// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"82069ed4","342":"caa5db95","351":"dc71991a","453":"21b49e9b","658":"f7fc3760","835":"ff31a661"}[chunkId] + ".chunk.js";
};